import { createContext } from "react";

const shopsContext = createContext();

export default shopsContext;